import { FileFormatInfo } from 'common/components/alchemy/FileInput/FileFormatInfo';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const DeleteOverridesFileFormatInfo = () => {
  const format = useFormatMessage();
  return (
    <FileFormatInfo
      columns={[
        { name: 'Venue Code', required: true },
        {
          name: 'Product Code',
          info: 'e.g. ABCDE-12345',
          groupInfo: format('forecasting.upload_overrides_one_code_should_be_used'),
          footnote: format('forecasting.delete_overrides_product_code_footnote'),
        },
        {
          name: 'External Product Code',
          info: format('inventory_replenishment.external_product_code_info'),
          footnote: format('forecasting.see_above'),
        },
        {
          name: 'Start Date',
          info: 'YYYY-MM-DD',
          required: true,
          groupInfo: format('forecasting.delete_overrides_by_date_range'),
        },
        { name: 'End Date', info: 'YYYY-MM-DD', required: true },
      ]}
    />
  );
};
